import { ToolCallMessagePartComponent } from "@assistant-ui/react";
import { CheckCircle2, Loader2 } from "lucide-react";

export const StorySearchTool: ToolCallMessagePartComponent = ({ result }) => {
    const isLoading = result === undefined;

    return (
        <div className="flex items-center gap-2 text-sm text-muted-foreground my-2 ml-1">
            {isLoading ? (
                <Loader2 className="h-3.5 w-3.5 animate-spin" />
            ) : (
                <CheckCircle2 className="h-3.5 w-3.5 text-primary" />
            )}
            <span>Understanding your Story base</span>
        </div>
    );
};
